import React, { useState } from 'react';
import {
  Box,
  Flex,
  IconButton,
  Image,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  HStack,
  Divider,
} from '@chakra-ui/react';
import { ChevronLeftIcon, ChevronRightIcon, CloseIcon } from '@chakra-ui/icons';

const ProductSidebar = ({
  product,
  currentImageIndex,
  setCurrentImageIndex,
  onClose,
  isImagePopupOpen,
  openImagePopup,
  closeImagePopup,
  placeholderImage = '/placeholder-product.jpeg',
}) => {
  const [modalImageIndex, setModalImageIndex] = useState(currentImageIndex);

  const showPreviousImage = () => {
    setModalImageIndex((prevIndex) =>
      prevIndex === 0 ? product.images.length - 1 : prevIndex - 1
    );
  };

  const showNextImage = () => {
    setModalImageIndex((prevIndex) =>
      prevIndex === product.images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const hasImages = product.images && product.images.length > 0;

  return (
    <Box
      width="400px"
      bg="gray.50"
      p="6"
      borderRadius="md"
      boxShadow="lg"
      position="sticky"
      top="0" // Start sticking at the top
      maxHeight="100%" // Prevent sidebar from being larger than parent
      overflowY="auto" // Add scroll if content overflows
      display="flex"
      flexDirection="column"
    >
      <IconButton
        icon={<CloseIcon />}
        aria-label="Close sidebar"
        size="sm"
        position="absolute"
        top="2"
        right="2"
        onClick={onClose}
      />
      <Flex direction="column" align="center" mb="4">
        <Image
          src={hasImages ? product.images[currentImageIndex]?.image : placeholderImage}
          alt={product.name}
          boxSize="250px"
          objectFit="cover"
          borderRadius="md"
          cursor={hasImages ? 'pointer' : 'default'}
          onClick={hasImages ? openImagePopup : undefined}
        />
      </Flex>
      <Box textAlign="left">
        <Text fontSize="lg" fontWeight="bold" mb="4">
          {product.name}
        </Text>
        <Text fontSize="md" color="gray.600" mb="4">
          {product.description}
        </Text>
        <Text fontSize="sm" color="gray.600" mb="4">
          Каталожний номер: {product.catalog_number}
        </Text>
        <Text fontSize="sm" color="gray.600" mb="4">
          Одиниця вимірювання: {product.unit_measurement}
        </Text>
        <Text fontSize="sm" color="gray.600" mb="4">
          ПДВ: {product.is_vat ? 'Так' : 'Ні'}
        </Text>
        <Text fontSize="sm" color="gray.600" mb="4">
          Кількість: {product.stock_quantity}
        </Text>
        <Text fontSize="sm" color="gray.600" mb="4">
          Країна виробник: {product.country_name}
        </Text>
        <Divider my="4" />
        <Box>
          <Text fontSize="lg" fontWeight="bold" color="gray.700" mb="2">
            Ціна: {Number(product.price).toFixed(2)} грн
          </Text>
          {product.is_vat && (
            <Text fontSize="lg" fontWeight="bold" color="blue.600">
              Ціна з ПДВ: {Number(product.price_with_vat).toFixed(2)} грн
            </Text>
          )}
        </Box>
      </Box>

      {/* Fullscreen Image Modal */}
      {hasImages && (
        <Modal isOpen={isImagePopupOpen} onClose={closeImagePopup} size="4xl">
          <ModalOverlay />
          <ModalContent>
            <ModalBody p="4" display="flex" flexDirection="column" alignItems="center">
              <Flex align="center" justify="space-between" mb="4" width="100%">
                <IconButton
                  icon={<ChevronLeftIcon />}
                  aria-label="Previous image"
                  onClick={showPreviousImage}
                />
                <Image
                  src={product.images[modalImageIndex]?.image}
                  alt={product.name}
                  boxSize="500px"
                  objectFit="cover"
                />
                <IconButton
                  icon={<ChevronRightIcon />}
                  aria-label="Next image"
                  onClick={showNextImage}
                />
              </Flex>
              <HStack spacing="4" overflowX="auto" maxWidth="100%">
                {product.images.map((img, index) => (
                  <Image
                    key={index}
                    src={img.image}
                    alt={`Thumbnail ${index}`}
                    boxSize="80px"
                    objectFit="cover"
                    borderRadius="md"
                    cursor="pointer"
                    border={modalImageIndex === index ? '2px solid blue' : 'none'}
                    onClick={() => setModalImageIndex(index)}
                  />
                ))}
              </HStack>
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
    </Box>
  );
};

export default ProductSidebar;
